// app/javascript/components/Conversation.jsx

import React from 'react';
import SendbirdProvider from "@sendbird/uikit-react/SendbirdProvider";
import '@sendbird/uikit-react/dist/index.css';
import GroupChannelPage from "./GroupChannelPage";
import FallbackGroupChannelPage from "./FallbackGroupChannelPage";
import SendbirdChat from "@sendbird/chat";

const colorSet = {
    '--sendbird-light-primary-500': '#052939',
    '--sendbird-light-primary-400': '#1598d1',
    '--sendbird-light-primary-300': '#31b4ed',
    '--sendbird-light-primary-200': '#96cae1',
    '--sendbird-light-primary-100': '#d9d9d94d',
    '--sendbird-light-background-100': '#ffffff',
}

export default function Conversation({userId, accessToken, channelUrl, conversationId}) {
    const ENV_KEYS = [
        'RAILS_ENV',
        'SENDBIRD_APP_ID',
        'SENDBIRD_CUSTOM_API_HOST',
        'SENDBIRD_CUSTOM_WEBSOCKET_HOST'
    ];

    const computeSdkLogLevel = (railsEnv) => (railsEnv === 'production' ? 'error' : 'warn');

    const [error, setError] = React.useState(null);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [appId, setAppId] = React.useState(null);
    const [customApiHost, setCustomApiHost] = React.useState(null);
    const [customWebSocketHost, setCustomWebSocketHost] = React.useState(null);
    const [sdkLogLevel, setSdkLogLevel] = React.useState('warn');
    const [useFallback, setUseFallback] = React.useState(false);

    React.useEffect(() => {
        $.ajax({
            url: '/configs/fetch_env_vars',
            method: 'GET',
            data: {keys: ENV_KEYS},
            dataType: 'json'
        }).then((result) => {
                if (!result['SENDBIRD_APP_ID']) {
                    window.sentry.captureMessage('SENDBIRD_APP_ID is not set');
                }
                setAppId(result['SENDBIRD_APP_ID'] || null);
                setCustomApiHost(result['SENDBIRD_CUSTOM_API_HOST'] || null);
                setCustomWebSocketHost(result['SENDBIRD_CUSTOM_WEBSOCKET_HOST'] || null);
                setSdkLogLevel(computeSdkLogLevel(result['RAILS_ENV']));
                setIsLoaded(true);
            },
            (err) => {
                window.sentry?.captureException(err);
                setError(err);
                setIsLoaded(true);
            }
        );
    }, []);


    React.useEffect(() => {
        if (!isLoaded || !appId || !userId || !accessToken) return;

        const sb = SendbirdChat.init({appId, modules: []});
        sb.connect(userId, accessToken).then(() => {
            setUseFallback(false);
        }).catch((err) => {
            window.sentry?.captureException?.(err);
            setUseFallback(true);
        });
    }, [isLoaded, appId, userId, accessToken]);

    if (error) {
        return <div>Error: {error.message}</div>;
    }
    if (!isLoaded) {
        return <div>Loading...</div>;
    }

    if (useFallback) {
        return (
            <div className="messaging-container mt-0 messaging-container-position">
                <FallbackGroupChannelPage
                    conversationId={conversationId}
                    channelUrl={channelUrl}
                    userId={userId}
                />
            </div>
        );
    }

    return (
        <div className="messaging-container mt-0 messaging-container-position">
            <SendbirdProvider
                appId={appId}
                userId={userId}
                accessToken={accessToken}
                {...(customApiHost ? {customApiHost} : {})}
                {...(customWebSocketHost ? {customWebSocketHost} : {})}
                colorSet={colorSet}
                uikitOptions={{
                    groupChannel: {
                        enableMarkdownForUserMessage: true
                    }
                }}
                sdkInitParams={{localCacheEnabled: false}}
                config={{logLevel: sdkLogLevel}}
            >
                <GroupChannelPage
                    channelUrl={channelUrl}
                    conversationId={conversationId}
                />
            </SendbirdProvider>
        </div>
    );
}